import * as FetchPlus from './index.js';

if (!globalThis.webqit) globalThis.webqit = {}
Object.assign(globalThis.webqit, FetchPlus);